<template>
  <div
    class="position-absolute h-100 d-flex w-100 overlay"
    :style="{ 'z-index': 10 }"
  >
    <div class="m-auto d-flex flex-column">
      <p class="text-center font-size-22 font-weight-semibold mx-auto">
        {{ message }}
      </p>
      <fa-icon
        icon="circle-notch"
        :size="notchSize"
        class="text-primary mx-auto"
        spin
      ></fa-icon>
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class VContentLoading extends Vue {
  @Prop({ default: "3x" })
  readonly notchSize!: string;
  @Prop()
  readonly message?: string;
}
</script>

<style lang="scss">
@import "../styles/vue";
.overlay {
  background: rgba($white, 0.7);
}
.overlay.light {
  background: rgba($gray-100, 0.7);
}
</style>
